<img mat-button [matMenuTriggerFor]="filter" src="https://agcdn.altametrics.com/hw-img/DEV/other/filter.svg" class="filter-icon dropdown-toggle" />
<mat-menu #filter="matMenu">
    <div class="filter-list ">
        <div class="filter-option-list">
            <ul class="filter-option-value">
                <li class="active">Text</li>
                <li>Pin</li>
            </ul>
        </div>
        <div class="filter-option-wrapper active">
            <div class="filter-option">
                <input class="search-box form-control" />
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                    <label class="form-check-label" for="autoSizingCheck2">
                        (Select All)
                    </label>
                </div>
            </div>
            <ul class="filter-list-item">
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            Hindi
                        </label>
                    </div>
                </li>
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            English
                        </label>
                    </div>
                </li>
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            French
                        </label>
                    </div>
                </li>
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            Russian
                        </label>
                    </div>
                </li>
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            Arabian
                        </label>
                    </div>
                </li>
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            Italian
                        </label>
                    </div>
                </li>
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            Turkish
                        </label>
                    </div>
                </li>
            </ul>
            <div class="filter-action">
                <button class="btn btn-sm btn-primary">Reset Filter</button>
            </div>
        </div>
        <div class="filter-option-wrapper">
            <div class="filter-option">
                Pin to
            </div>
            <ul class="filter-list-item">
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            Left
                        </label>
                    </div>
                </li>
                <li>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" id="autoSizingCheck2">
                        <label class="form-check-label" for="autoSizingCheck2">
                            None
                        </label>
                    </div>
                </li>

            </ul>
            <div class="filter-action">
                <button class="btn btn-sm btn-primary">Reset Filter</button>
            </div>
        </div>
    </div>
</mat-menu>
